// extracted by mini-css-extract-plugin
export default {"button":"ScrollToTop_button__XzcUm","visible":"ScrollToTop_visible__NV1Cl"};